const sleep = async (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
}

/*
    "is v1 larger than v2?"
    -1 : v1 is smaller than v2
     0 : v1 and v2 are equal
     1 : v1 is large than v2
*/
const compareVersions = (v1, v2) => {
    const v1Split = v1.split('.').map(x => parseInt(x))
    const v2Split = v2.split('.').map(x => parseInt(x))
    if (v1Split[0] < v2Split[0]) {
        return -1
    } else if (v1Split[0] > v2Split[0]) {
        return 1
    } else {
        if (v1Split[1] < v2Split[1]) {
            return -1
        } else if (v1Split[1] > v2Split[1]) {
            return 1
        } else {
            if (v1Split[2] < v2Split[2]) {
                return -1
            } else if (v1Split[2] > v2Split[2]) {
                return 1
            } else {
                return 0
            }
        }
    }
}

export {
    sleep,
    compareVersions
}